import { FC } from 'react';
import styled from 'styled-components';
import { Tooltip, Toggletip } from 'ui/tooltip';
import { localizePercentageValue } from 'utils/i18nHelpers';

import type { TooltipProps } from 'ui/tooltip/types';

type MeterTipProps = {
  value: number;
  total: number;
  tooltipContent: TooltipProps['tooltipContent'];
  hasTooltip?: boolean;
  hasToggletip?: boolean;
};

const StyledToggletip = styled(Toggletip)<{ percentage: string }>`
  width: ${({ percentage }) => percentage};
`;

const StyledTooltip = styled(Tooltip)<{ percentage: string }>`
  width: ${({ percentage }) => percentage};
`;

const StyledTrigger = styled.div`
  display: inline-block;
  width: 100%;
`;

export const DATA_TEST = {
  tooltip: 'meter-chart-tooltip',
  toggletip: 'meter-chart-toggletip',
};

export const MeterTip: FC<React.PropsWithChildren<MeterTipProps>> = ({
  children,
  value,
  total,
  tooltipContent,
  hasTooltip,
}) => {
  /** if hasTooltip isn't defined it will be assumed it is Toggletip due to the condition to rendner this component */
  const dataTest = hasTooltip ? DATA_TEST.tooltip : DATA_TEST.toggletip;
  const localizedPercentageValue = localizePercentageValue((value / total) * 100);
  const MeterChartTip = hasTooltip ? StyledTooltip : StyledToggletip;

  return (
    <MeterChartTip percentage={localizedPercentageValue} tooltipContent={tooltipContent}>
      <StyledTrigger data-test={dataTest}>{children}</StyledTrigger>
    </MeterChartTip>
  );
};
